import { REDUCER } from '../reducers/reducersConst';

export let toggleMeetCookie = () => {
  return {
    type: REDUCER.COOKIES.TOGGLE_MEET_COOKIE
  };
};
